module.exports = {"id":"181349","name":"Alexander Gerndt","rating":"73","photo":"./data/images/photos/0/181349.png","club":{"name":"FC Lugano","logo":"./data/images/clubs/FCLugano.png"},"positions":["BU","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexanderGerndt0.json
// module id = 229
// module chunks = 0